import Vue from 'vue'
import { mapState } from 'vuex'

import { updateUserAgreement } from '@/api/user'
import BackButton from '@/components/back-button/back-button.vue'
import Loading from '@/components/loading/loading.vue'
import TermConditionDialog from '@/components/dialog/term-condition-dialog/index.vue'
import { corpMixins } from '@/mixins/corp-mixins'
import { isMobile } from '@/lib/helpers/index.ts'

export default Vue.extend({
  mixins: [corpMixins],
  components: {
    Loading,
    BackButton,
    TermConditionDialog
  },
  data () {
    return {
      showTermConditionDialog: false,
      acceptedRoutes: [
        '/contents/:id',
        '/units/:id',
        '/units/:id/results/:implId',
        '/units/:id/results',
        '/contents/:id/buy_plan',
        '/contents/:id/buy_plan/:plan_id',
        '/units/:id/results/:implId'
      ],
      isMobile: isMobile()
    }
  },
  computed: {
    ...mapState(['title', 'loading', 'message', 'menu', 'user']),
    preview () {
      if (this.user.image) {
        return process.env.VUE_APP_API_BASE_URL + this.user.image
      }
      return null
    },
    backUrl () {
      // 履歴 画面
      const backResult = ['/units/:id/results']
      if (backResult.includes(this.$route.matched[1].path)) {
        const contentId = this.$route.query.content

        return `/contents/${contentId}`
      }

      // 結果詳細 画面
      const backOneUrl = ['/units/:id/results/:implId']
      if (backOneUrl.includes(this.$route.matched[1].path)) {
        const unitId = this.$route.params.id
        const contentId = this.$route.query.content

        // finishパラメータがある場合は結果一覧画面に戻る
        if (this.$route.query.finish) {
          return `/units/${unitId}?content=${contentId}`
        } else {
          return `/units/${unitId}/results?content=${contentId}`
        }
      }

      const backToBuyPlanUrl = ['/contents/:id/buy_plan/:plan_id']
      if (backToBuyPlanUrl.includes(this.$route.matched[1].path)) {
        return `/contents/${this.$route.params.id}/buy_plan`
      }

      const backToContentUrl = ['/contents/:id/buy_plan']
      if (backToContentUrl.includes(this.$route.matched[1].path)) {
        return `/contents/${this.$route.params.id}`
      }

      const toContent = ['/units/:id']
      if (toContent.includes(this.$route.matched[1].path)) {
        return `/contents/${this.$route.query.content}`
      }

      const contentBackUrl = '/contents/:id'
      if (contentBackUrl === this.$route.matched[1].path) {
        const validContentBackUrl = ['/dashboard', '/contents']
        return validContentBackUrl.includes(this.fromUrl) ? this.fromUrl : '/dashboard'
      }

      return '/dashboard'
    },
    includedPage () {
      return this.acceptedRoutes.includes(this.$route.matched[1].path)
    },
    showCompanyDepartment() {
      const companyName = this.user.company_name
      const departmentName = this.user.department_branch
      return (companyName && departmentName) ? companyName + '\u00A0\u00A0' + departmentName : companyName
    }
  },
  mounted () {
    const requiredAgreement = this.user.agreements.filter(item => item.require_confirmation)
    this.showTermConditionDialog = requiredAgreement.length > 0
  },
  methods: {
    handleClickLogout () {
      this.$store.dispatch('logout')
    },
    submitAgreement (v) {
      updateUserAgreement(v)
        .then(() => {
          this.showTermConditionDialog = false
        })
        .catch((e) => {
          //
        })
    }
  }
})
